<template>
  <div class="api-log-container">
    <el-card class="api-log-card">
      <h2 class="api-log-title">API 调用日志</h2>
      <el-form :inline="true" :model="filter" @submit.native.prevent="onSearch" style="margin-bottom: 16px;">
        <el-form-item label="关键词">
          <el-input v-model="filter.q" placeholder="接口/参数/状态" style="width: 180px" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="起止时间">
          <el-date-picker v-model="filter.dates" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 260px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch" :loading="loading">查询</el-button>
          <el-button @click="exportCsv" style="margin-left:8px">导出CSV</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="logs" border stripe style="width: 100%" :fit="true">
        <el-table-column prop="endpoint" label="接口" width="120" />
        <el-table-column prop="params" label="参数" min-width="180">
          <template slot-scope="scope">
            <span class="log-link" @click="showDetail(scope.row, 'params')">{{ formatParams(scope.row.params) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 200 ? 'success' : 'danger'">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="message" label="结果" width="120">
          <template slot-scope="scope">
            <span class="log-link" @click="showDetail(scope.row, 'message')">{{ scope.row.message }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ip" label="IP" width="120" />
        <el-table-column prop="create_time" label="时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="showDetail(scope.row, 'all')">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 16px 0; text-align: right">
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="onPageChange"
        />
      </div>
      <el-dialog :visible.sync="detailVisible" title="日志详情" width="600px">
        <pre style="white-space: pre-wrap;word-break: break-all;">{{ detailContent }}</pre>
        <span slot="footer" class="dialog-footer">
          <el-button @click="detailVisible = false">关闭</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ApiLog',
  data() {
    return {
      logs: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      filter: {
        q: '',
        dates: []
      },
      detailVisible: false,
      detailContent: ''
    }
  },
  created() {
    this.fetchLogs();
  },
  methods: {
    async fetchLogs() {
      this.loading = true;
      try {
        // 假设后端支持 /user/apiLog?page&pageSize&q&start&end
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          q: this.filter.q,
        };
        if (this.filter.dates && this.filter.dates.length === 2) {
          params.start = this.filter.dates[0];
          params.end = this.filter.dates[1];
        }
        const res = await this.$axios.get('/user/apiLog', { params, headers: this.authHeader() });
        if (res.data && res.data.code === 200) {
          this.logs = res.data.data.logs || [];
          this.total = res.data.data.total || 0;
        } else {
          this.logs = [];
          this.total = 0;
        }
      } catch {
        this.logs = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      this.page = 1;
      this.fetchLogs();
    },
    onPageChange(page) {
      this.page = page;
      this.fetchLogs();
    },
    formatParams(params) {
      if (!params) return '';
      if (typeof params === 'string') return params;
      try {
        return JSON.stringify(params);
      } catch {
        return '';
      }
    },
    formatDate(val) {
      if (!val) return '';
      const d = new Date(val);
      const pad = n => n.toString().padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    showDetail(row, type) {
      if (type === 'params') {
        this.detailContent = typeof row.params === 'string' ? row.params : JSON.stringify(row.params, null, 2);
      } else if (type === 'message') {
        this.detailContent = row.message;
      } else {
        this.detailContent = JSON.stringify(row, null, 2);
      }
      this.detailVisible = true;
    },
    exportCsv() {
      if (!this.logs.length) return;
      const header = ['接口','参数','状态','结果','IP','时间'];
      const rows = this.logs.map(l => [
        l.endpoint,
        this.formatParams(l.params),
        l.status,
        l.message,
        l.ip,
        this.formatDate(l.create_time)
      ]);
      const csv = [header, ...rows].map(r => r.map(v => '"' + (v || '').replace(/"/g,'""') + '"').join(',')).join('\n');
      const blob = new Blob([csv], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'apiLog.csv';
      a.click();
      URL.revokeObjectURL(url);
    },
    authHeader() {
      const token = localStorage.getItem('token');
      return token ? { Authorization: 'Bearer ' + token } : {};
    }
  }
}
</script>

<style scoped>
.api-log-container {
  max-width: 900px;
  margin: 32px auto;
}
.api-log-card {
  padding: 24px 24px 8px 24px;
}
.api-log-title {
  text-align: center;
  margin-bottom: 24px;
  font-weight: 500;
}
.log-link {
  color: #409EFF;
  cursor: pointer;
  text-decoration: underline;
}
.log-link:hover {
  color: #66b1ff;
}
</style> 